import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalAccountService {

  constructor(
    private httpService: HttpService
  ) { }

  changePassword(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/changePassword', data, permission);
  }

  search(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/search', data, permission);
  }

  getCanBoChuaCoTaiKhoan(permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/getCanBoChuaCoTaiKhoan', {}, permission);
  }

  add(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/add', data, permission);
  }
  exportBaoCaoAccountSearch(data: any, permission: any): Observable<any> {
    return this.httpService.downloadAttachFilePermission('portal-accounts/exportBaoCaoAccount', data, permission);
  }

  edit(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/edit', data, permission);
  }

  delete(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/delete', data, permission);
  }
  getDanhSachNhanVienById_nhanVien(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/getDanhSachNhanVienById_nhanVien', data, permission);
  }
  getDanhSachDuongByPortalAccount(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/getDanhSachDuongByPortalAccount', data, permission);
  }
  updateQuyenQuanLyByPortalAccount(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/updateQuyenQuanLyByPortalAccount', data, permission);
  }

  //#region quyền giám sát
  // Create a new item
  getDoanDuongQuyenGiamSat(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/doanduong-quyengiamsat/get', data, permission);
  }
  insertDoanDuongQuyenGiamSat(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/doanduong-quyengiamsat/insert', data, permission);
  }
  // Update a item with condition {id: id}
  updateDoanDuongQuyenGiamSat(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/doanduong-quyengiamsat/update', data, permission);
  }
  // Delete a item with id
  deleteDoanDuongQuyenGiamSat(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/doanduong-quyengiamsat/delete', data, permission);
  }
  getDanhSachDuongGiamSatByPortalAccount(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/getDanhSachDuongGiamSatByPortalAccount', data, permission);
  }
  getDanhSachDuongChuaGiamSat(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/getDanhSachDuongChuaGiamSat', data, permission);
  }
  updateQuyenGiamSatListDuong(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/updateQuyenGiamSatListDuong', data, permission);
  }
  checkUsername(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('portal-accounts/checkUsername', data, permission);
  }
  addAdminAccount(data: any, permission: any,action : any): Observable<any> {
    return this.httpService.postToHrm('admins/account/create', data, permission,action);
  }
  updateAdminAccount(data: any, permission: any,action : any): Observable<any> {
    return this.httpService.postToHrm('admins/account/update', data, permission,action);
  }
  deleteAdminAccount(data: any, permission: any,action : any): Observable<any> {
    return this.httpService.postToHrm('admins/account/delete', data, permission,action);
  }
  loginAdminAccount(data: any, permission: any,action : any): Observable<any> {
    return this.httpService.postToHrm('admins/account/login', data, permission,action);
  }
  changePasswordAdminAccount(data: any, permission: any,action : any): Observable<any> {
    return this.httpService.postToHrm('admins/account/change_password', data, permission,action);
  }
  //#endregion

  getListVaiTro(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('dm/vai-tro/search', data, permission);
  }
  createVaiTro(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('dm/vai-tro/create', data, permission);
  }
  updateVaiTro(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('dm/vai-tro/update', data, permission);
  }
  deleteVaiTro(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('dm/vai-tro/delete', data, permission);
  }
  getListAccount_type(data: any, permission: any): Observable<any> {
    return this.httpService.postPermission('dm/vai-tro/getListAccountType', data, permission);
  }
}
